import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Observable, of } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';
import { setTemporarySession } from '../../temporary-sessions';

interface TokenResponse {
  data: {
    token: string;
  };
}

@Injectable()
export class NotificationAuthGuard {
  constructor(private router: Router, private http: HttpClient, private snackbarService: SnackbarService) {}

  canActivate(next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const token = next.queryParams?.q;
    if (!token) {
      this.snackbarService.openErrorSnack('Provided token is null');
      this.router.navigate(['error']);
      return of(false);
    }

    return this.http
      .post<TokenResponse>(`/nsInternalApi/v3/token/`, {
        queryString: token,
      })
      .pipe(
        take(1),
        switchMap((data) => {
          if (!data || data.data?.token === '') {
            this.snackbarService.openErrorSnack('Provided token is not valid');
            this.router.navigate(['error']);
            return of(false);
          }
          setTemporarySession(data.data.token);
          return of(true);
        }),
        catchError((err) => {
          this.snackbarService.openErrorSnack(err.message);
          this.router.navigate(['error']);
          return of(false);
        }),
      );
  }
}
